import Head from 'next/head'
import { createContext } from 'react'
import useCheckout from '../hooks/use-checkout'

export const CheckoutContext = createContext()

function _RenderDelegate({ checkout, children }) {
  const state = useCheckout(checkout)

  return <CheckoutContext.Provider value={state}>{children}</CheckoutContext.Provider>
}

export default function CheckoutContextProvider(props) {
  return (
    <>
      <Head>
        {/* eslint-disable-next-line @next/next/no-sync-scripts */}
        <script src="https://js.paystack.co/v1/inline.js"></script>
      </Head>
      <_RenderDelegate {...props} />
    </>
  )
}
